import { render } from "./FortigateProfileList.vue?vue&type=template&id=974aac72"
import script from "./FortigateProfileList.vue?vue&type=script&lang=js"
export * from "./FortigateProfileList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__